import { useLocale } from "@commercekit/remix";
import {
  getYotpoConfig,
  YOTPO_WIDGET_LOADER_BASE_URL,
} from "~/lib/yotpo/config";

export const useYotpo = () => {
  const { localeFullName } = useLocale();
  const config = getYotpoConfig(localeFullName);
  if (!config) {
    return undefined;
  }
  return {
    ...config,
    src: `${YOTPO_WIDGET_LOADER_BASE_URL}/${config.appKey}`,
  };
};
